import { createStitches, defaultThemeMap } from '@stitches/react';
import {
  colors,
  fontSizes,
  fontWeights,
  fonts,
  radii,
  space,
} from '@/styles/stitches/tokens';

export const {
  styled,
  css,
  globalCss,
  keyframes,
  theme,
  createTheme,
  config,
  getCssText,
} = createStitches({
  themeMap: {
    ...defaultThemeMap,
    height: 'space',
    width: 'space',
  },
  theme: {
    colors,
    fontSizes,
    fontWeights,
    fonts,
    radii,
    space,
  },
  media: {
    lg: '(max-width: 992px)',
    md: '(max-width: 768px)',
    sm: '(max-width: 576px)',
  },
});
